import { render, staticRenderFns } from "./BpmnEditor.vue?vue&type=template&id=2ee72dbf"
import script from "./BpmnEditor.vue?vue&type=script&lang=js"
export * from "./BpmnEditor.vue?vue&type=script&lang=js"
import style0 from "./BpmnEditor.vue?vue&type=style&index=0&id=2ee72dbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports